module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-card', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("忘記密碼")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-5 input-group",
    attrs: {
      "label": "帳號",
      "hint": "請輸入您的帳號",
      "required": ""
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.validation()
      }
    }
  }, [_vm._v("送出")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b87fb7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 776
// module chunks = 1